import React, {useRef} from 'react';
import {
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {createStyles} from '../../utils/createStyles';
import {Avatar} from '@rneui/themed';
import Icon from 'react-native-vector-icons/Ionicons';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {saveUserInfo, selectUserInfo} from '../../store/user';
import {staticDictionary} from '../../utils/dictionary';
import {useNavigation} from '@react-navigation/native';
import TakeSelectPhoto, {
  TakeSelectPhotoProps,
  TakeSelectPhotoRefAttr,
} from '../../components/TakeSelectPhoto';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
import {updateAvatarApi} from '../../API/user';
import useGetDeviceInfo from '../../hooks/useGetDeviceInfo';
import Toast from 'react-native-toast-message';
import {ossImg} from '../../utils/oss';

export default function UserCenter(): React.JSX.Element {
  const takeRef = useRef<TakeSelectPhotoRefAttr>(null);
  const dispatch = useAppDispatch();
  const {uniqueId} = useGetDeviceInfo();
  const navigation = useNavigation();
  const userInfo = useAppSelector(selectUserInfo);
  const gradeName =
    staticDictionary.userGradeList.find(
      item => item.id === userInfo.curriculumSetup.xkwGradeId,
    )?.name || '';
  const toRecord = () => {
    navigation.navigate('RecordIndex');
  };
  const toSetting = () => {
    navigation.navigate('SettingList');
  };
  const changeAvatar = () => {
    takeRef.current?.open();
  };
  const onTakeFinish: TakeSelectPhotoProps['onTakeFinish'] = (action, img) => {
    console.log('onTakeFinish');
    console.log(action, img);
    if (img) {
      showGlobalLoading({
        text: '上传中...',
      });
      takeRef.current?.close();
      updateAvatarApi({
        file: img.data as string,
        userId: userInfo.id,
        deviceSn: uniqueId,
      }).then(res => {
        hideGlobalLoading();
        if (res.status === 200) {
          Toast.show({
            type: 'success',
            text1: '上传成功',
          });
          dispatch(saveUserInfo(res.data));
        } else {
          Toast.show({
            type: 'error',
            text1: '上传失败: ' + res.msg,
          });
        }
      });
    }
  };
  return (
    <>
      <ImageBackground
        style={styles.flex1}
        source={require('../../assets/images/userCenter/bg.png')}>
        <View style={styles.viewTop}>
          {/*头像*/}
          <TouchableOpacity onPress={changeAvatar}>
            <Avatar
              containerStyle={styles.avatar}
              size={64}
              rounded
              imageProps={{
                resizeMode: 'cover',
              }}
              avatarStyle={{width: '100%', height: '100%'}}
              source={
                userInfo.avatar
                  ? {uri: ossImg(userInfo.avatar)}
                  : require('../../assets/images/av.png')
              }
            />
          </TouchableOpacity>
          <View style={styles.userInfo}>
            <View style={styles.userName}>
              <Text style={styles.nameText}>{userInfo.name}</Text>
              <Icon
                name={userInfo.gender === 2 ? 'female-outline' : 'male-outline'}
                size={20}
                color={'#333'}
              />
            </View>
            <View style={styles.userMobile}>
              <Text style={styles.mobileText}>{userInfo.mobile}</Text>
              <View style={styles.grade}>
                <Text style={styles.gradeText}>{gradeName}</Text>
              </View>
            </View>
          </View>
          <TouchableOpacity
            activeOpacity={0.6}
            style={styles.editWrap}
            onPress={() => navigation.navigate('Register', {isEdit: true})}>
            <Image
              style={styles.editImg}
              source={{
                uri: 'https://media.oss.leziedu.com/webapp/classroom/web-chat/%E5%AE%B9%E5%99%A8%20(1).png',
              }}
            />
            <Text style={styles.editText}>学生信息</Text>
          </TouchableOpacity>
        </View>
        <ScrollView style={styles.viewBottom}>
          <View style={styles.iconWrap}>
            <TouchableOpacity onPress={toRecord} activeOpacity={0.6}>
              <Image
                style={[styles.iconImg, {aspectRatio: 2352 / 1077}]}
                resizeMode={'contain'}
                source={require('../../assets/images/userCenter/record.png')}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={toSetting}
              onLongPress={() => navigation.navigate('SysSetting')}
              delayLongPress={5000}
              activeOpacity={0.6}>
              <Image
                style={[styles.iconImg2, {aspectRatio: 2352 / 1077}]}
                resizeMode={'contain'}
                source={require('../../assets/images/userCenter/setting.png')}
              />
            </TouchableOpacity>
          </View>
          <View style={styles.iconWrap2}>
            <TouchableOpacity
              onPress={() => navigation.navigate('UseCDK')}
              activeOpacity={0.6}>
              <Image
                style={[styles.iconImg2, {aspectRatio: 2352 / 1077}]}
                resizeMode={'contain'}
                source={require('../../assets/images/userCenter/cdk.png')}
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => navigation.navigate('AboutOnePad')}
              activeOpacity={0.6}>
              <Image
                resizeMode={'contain'}
                style={[styles.iconImg2, {aspectRatio: 2352 / 1077}]}
                source={require('../../assets/images/userCenter/about.png')}
              />
            </TouchableOpacity>
          </View>
        </ScrollView>
      </ImageBackground>
      <TakeSelectPhoto
        ref={takeRef}
        onTakeFinish={onTakeFinish}
        cropOptions={{
          cropperCircleOverlay: true,
          showCropGuidelines: false,
          showCropFrame: false,
          freeStyleCropEnabled: false,
          width: 100,
          height: 100,
        }}
      />
    </>
  );
}

const styles = createStyles({
  // $outline: 1,
  flex1: {
    flex: 1,
  },
  viewTop: {
    position: 'relative',
    paddingLeft: '10rem',
    height: '28.4%',
    flexDirection: 'row',
    alignItems: 'center',
  },
  viewBottom: {
    flex: 1,
    backgroundColor: '#fff',
    borderTopLeftRadius: '4.15rem',
    borderTopRightRadius: '4.15rem',
  },
  avatar: {},
  editWrap: {
    position: 'absolute',
    bottom: '2.2rem',
    right: '8.6rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  editImg: {
    width: '1.6rem',
    height: '1.6rem',
  },
  editText: {
    marginLeft: '0.8rem',
    fontSize: '1.4rem',
    color: '#666666',
  },
  userInfo: {
    marginLeft: '2.4rem',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  userName: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  nameText: {
    marginRight: '0.8rem',
    fontSize: '2.2rem',
    color: '#333333',
  },
  userMobile: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mobileText: {
    color: '#333333',
    fontSize: '1.5rem',
  },
  grade: {
    marginLeft: '0.8rem',
    height: '2.3rem',
    width: '5.6rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.6rem',
    backgroundColor: '#33CD8F',
  },
  gradeText: {
    fontSize: '1.4rem',
    color: '#fff',
  },
  iconWrap: {
    marginTop: '4.1rem',
    paddingHorizontal: '4.1rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  iconWrap2: {
    paddingHorizontal: '4.1rem',
    marginTop: '4.1rem',
    marginBottom: '4.1rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  iconImg: {
    marginRight: '6.2rem',
    width: '39rem',
    height: undefined,
  },
  iconImg2: {
    width: '39rem',
    height: undefined,
  },
});
